module.exports = __webpack_public_path__ + "img/中国火车头体育协会@3x.e12816d2.png";